import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CambioViaPagoHomeComponent } from './pages/cambio-via-pago-home/cambio-via-pago-home.component';
import { ROUTING_CAMBIO_VIA_PAGO_PENSION } from '../shared/common/constants/url.constant';
import { CambioViaPagoComponent } from './pages/cambio-via-pago/cambio-via-pago.component';
import { CambioViaPagoDatosPersonalesComponent } from './pages/cambio-via-pago-datos-personales/cambio-via-pago-datos-personales.component';
import { CambioViaPagoDatosBancariosComponent } from "./pages/cambio-via-pago-datos-bancarios/cambio-via-pago-datos-bancarios.component";
import { CambioViaPagoConfirmarComponent } from "./pages/cambio-via-pago-confirmar/cambio-via-pago-confirmar.component";
import { CambioViaPagoComprobanteComponent } from "./pages/cambio-via-pago-comprobante/cambio-via-pago-comprobante.component";
import { SolicitudErrorComponent } from "@shared/components/solicitud-error/solicitud-error.component";

const CAMBIO_VIA_PAGO_PENSION_ROUTES: Routes = [
  {
    path: "",
    redirectTo: ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_HOME,
    pathMatch: "full",
  },
  {
    path: ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_HOME,
    component: CambioViaPagoHomeComponent,
  },
  {
    path: ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO,
    component: CambioViaPagoComponent,
    children: [
      {
        path: "",
        redirectTo: ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_DATOS_PERSONALES,
        pathMatch: "full",
      },
      {
        path: ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_DATOS_PERSONALES,
        component: CambioViaPagoDatosPersonalesComponent,
      },
      {
        path: ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_DATOS_BANCARIOS,
        component: CambioViaPagoDatosBancariosComponent,
      },
      {
        path: ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_CONFIRMAR,
        component: CambioViaPagoConfirmarComponent,
      },
    ],
  },
  {
    path: ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_COMPROBANTE,
    component: CambioViaPagoComprobanteComponent,
  },
  {
    path: ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_ERROR,
    component: SolicitudErrorComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(CAMBIO_VIA_PAGO_PENSION_ROUTES)],
  exports: [RouterModule],
})
export class CambioViaPagoPensionRoutingModule {}
